import { Injectable } from '@angular/core';
import { AccountType, AccountTypes } from '../../models/type/type';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GlobalService {
  private accountType$: BehaviorSubject<AccountType | undefined> =
    new BehaviorSubject<AccountType | undefined>(undefined);

  constructor() {}

  /**
   * Salva la tipologia e successivamente il suo prefisso
   * @param tipologia
   */
  setAccountType(tipologiaName: string): void {
    switch (tipologiaName) {
      case AccountTypes.VET.name:
        this.accountType$.next(AccountTypes.VET);
        break;
      case AccountTypes.PRO.name:
        this.accountType$.next(AccountTypes.PRO);
        break;
      default:
        this.accountType$.next(undefined);
        console.log('Tipologia Account inesistente o non supportata');
    }
  }

  /**
   * Restituisce l'oggetto tipologia
   * @returns è un observable
   */
  getAccountType(): Observable<AccountType | undefined> {
    return this.accountType$.asObservable();
  }

  /**
   * Rimuove la tipologia
   */
  clearAccountType(): void {
    this.accountType$.next(undefined);
  }
}
